<template>
  <section class="mt-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">申込登録</li>
        <li class="px-3">内容確認</li>
        <li class="px-3">商品注文</li>
        <li class="px-3">カート確認</li>
        <li class="here px-3">お届け/お支払</li>
        <li class="px-3">最終確認</li>
        <li class="px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">お届け先、お届け日、お支払方法</h3>
    <p class="exp">
      以下の必要な項目をご入力のうえ、確認画面へ進むを押してください。
    </p>

    <div class="form-member my-5">
      <div class="inner">
        <dl style="margin-bottom: 0; border-bottom: 0">
          <dt>お受取りについて<span class="rqr">必須</span></dt>
          <dd>
            初回のご注文はご本人受取りとなります。<br />
            同意いただける方は「本人が受取ることを同意する」にチェックをいれてください。<br />
            <input
              v-model="consent"
              ref="consent"
              id="chkBySelf"
              type="checkbox"
              class="check-01"
            />
            <label for="chkBySelf"
              ><strong>本人が受取ることを同意する</strong></label
            >
          </dd>
          <dt>お届け先<span class="rqr">必須</span></dt>
          <dd>
            <input
              v-model="isHome"
              id="rdoHomeY"
              name="home"
              type="radio"
              class="radio-01"
              value="true"
            />
            <label for="rdoHomeY">ご自宅</label>
            <input
              v-model="isHome"
              id="rdoHomeN"
              name="home"
              type="radio"
              class="radio-01 ml-2e"
              value="false"
            />
            <label for="rdoHomeN">ご自宅以外</label>
          </dd>
        </dl>

        <!-- ご自宅以外選択で追加 -->
        <dl
          v-show="isHome == 'false'"
          id="dlAddress"
          style="margin-bottom: 0; border-bottom: 0"
        >
          <dt style="width: 100%; float: none; background: #fff">
            ※ご自宅以外のお届け先をご記入ください。
          </dt>
          <dt>郵便番号<span class="rqr">必須</span></dt>
          <dd>
            〒
            <input
              v-model="zipCode2"
              ref="zipCode2"
              id="txtZipCode"
              type="text"
              class="input-name"
              placeholder="(例)2790032"
              style="ime-mode: disabled"
            />
            <button
              id="spnZipSearch"
              v-on:click="zipSearch"
              class="p-serch ml-3 mt-2"
            >
              住所検索</button
            ><br />
            <p class="fs-09">ハイフン(-)は除いてください。</p>
          </dd>
          <dt>住所<span class="rqr">必須</span></dt>
          <dd>
            <input
              v-model="part1OfAddress"
              ref="part1OfAddress"
              id="txtAddress1"
              maxlength="100"
              type="text"
              class="w-100"
              placeholder="(例)千葉県浦安市千鳥15-9"
              style="ime-mode: active"
            />
          </dd>
          <dt>
            住所<span class="fs-08">（フリガナ）</span
            ><span class="rqr">必須</span>
          </dt>
          <dd>
            <input
              v-model="addressKana"
              ref="addressKana"
              id="txtAddressKana"
              maxlength="300"
              type="text"
              class="w-100"
              placeholder="(例)チバケンウラヤスシチドリ15バンチ8"
              style="ime-mode: active"
            /><br />
            <p class="fs-09">カタカナで入力してください</p>
          </dd>
          <dt>住所<span class="fs-08">（建物名）</span></dt>
          <dd>
            <input
              v-model="part2OfAddress"
              ref="part2OfAddress"
              id="txtAddress2"
              maxlength="100"
              type="text"
              class="w-100"
              placeholder="(例)マナビスマンション101"
              style="ime-mode: active"
            />
          </dd>
          <dt>宛先</dt>
          <dd>
            <input
              v-model="part3OfAddress"
              ref="part3OfAddress"
              id="txtAddress3"
              maxlength="100"
              type="text"
              class="input-name"
              placeholder="(例)浦安 舞子"
              style="ime-mode: active"
            />
            <select
              v-model="part3Add"
              ref="part3Add"
              id="selAddress3Add"
              class="px-3"
            >
              <option value="">－</option>
              <option value="様方">様方</option>
              <option value="気付">気付</option>
            </select>
          </dd>
          <dt>電話番号<span class="rqr">必須</span></dt>
          <dd>
            <input
              v-model="telNo"
              ref="telNo"
              id="txtTel"
              maxlength="12"
              type="text"
              class="input-w30"
              placeholder="(例)9999999999"
              style="ime-mode: disabled"
            /><br />
            <p class="fs-09">ハイフン(-)は除いてください。</p>
          </dd>
        </dl>
        <!-- // ご自宅以外選択で追加 -->

        <dl>
          <dt>お届け指定日<span class="rqr">必須</span></dt>
          <dd>
            <select
              v-model="deliveryDate"
              ref="deliveryDate"
              id="cmbWantDay"
              class="px-3"
            >
              <option value="">－</option>
              <option v-for="date in deliveryDays" :key="date" :value="date">
                {{ date }}
              </option>
            </select>
          </dd>
          <dt>お届け時間帯<span class="rqr">必須</span></dt>
          <dd>
            <select
              v-model="deliveryTime"
              ref="deliveryTime"
              id="cmbWantTime"
              class="px-3"
            >
              <option value="">－</option>
              <option
                v-for="time in deliveryTimes"
                :key="time.Key"
                :value="time.Key"
              >
                {{ time.Value }}
              </option>
            </select>
          </dd>
          <dt>お支払方法<span class="rqr">必須</span></dt>
          <dd>
            <input
              id="rdoPayCod"
              v-model="paymentMethod"
              ref="paymentMethod"
              value="0"
              name="PayMethod"
              type="radio"
              class="radio-01"
            />
            <label for="rdoPayCod">代金引換</label>
            <input
              id="rdoPayBank"
              v-model="paymentMethod"
              ref="paymentMethod"
              value="1"
              name="PayMethod"
              type="radio"
              class="radio-01 ml-2e"
            />
            <label v-show="isPayBankDisp" for="rdoPayBank">銀行振込（前払い）</label>
            <input v-show="isPayBankDisp"
              id="rdoPayAtobarai"
              v-model="paymentMethod"
              ref="paymentMethod"
              value="5"
              name="PayMethod"
              type="radio"
              class="radio-01 ml-2e"
            />
            <label for="rdoPayAtobarai">後払い</label>
          </dd>
          <dd
            v-show="paymentMethod == '5'"
            id="dlAtobarai"
          >
            <div style="font-size: smaller; margin-left: 10px;">
              ※後払い手数料：0円<br>
              &nbsp;&nbsp;&nbsp;当サービスは(株)キャッチボールが運営します。下記注意事項を確認、同意の上ご利用ください。<br>
              <br>
              【注意事項】<br>
              &nbsp;&nbsp;&nbsp;(株)キャッチボールから請求書が送られます。請求書記載の期限内にお支払いいただけない場合などは、<br>
              &nbsp;&nbsp;&nbsp;再度の請求毎に390円(税込)の再請求手数料がかかります。<br>
              &nbsp;&nbsp;&nbsp;商品の配送先を配送業者の営業所止め（営業所来店引取り）、転送依頼することはできません。<br>
              &nbsp;&nbsp;&nbsp;ご利用者が未成年の場合、法定代理人の利用同意を得てください。<br>
              &nbsp;&nbsp;&nbsp;（株）キャッチボールは、<a href="https://www.catch-ball.jp/privacy/" target="_blank" rel="noreferrer noopener">プライバシーポリシー</a>に応じて個人情報および注文内容を適切に管理いたします。<br>
              &nbsp;&nbsp;&nbsp;その他詳細は、(株)キャッチボールのサービス<a href="https://atobarai-user.jp/omit/atobarai_unaccompanied/" target="_blank" rel="noreferrer noopener">ご利用規約</a>をご確認下さい。<br>
                <img id="AE" class="mr-2 mt-2" src="@/assets/img/atobarai_abp_450x126.jpg" alt="atobarai" />
              </div>
          </dd>
        </dl>
        <div
          class="d-flex justify-content-around text-center column_sp box-p-20"
        >
          <div>
            <router-link
              :to="{ path: '/registration/order/confirm' }"
              class="btn d-inline-block mt-5"
            >
              カートへ戻る
            </router-link>
          </div>
          <div>
            <button
              v-on:click="putData"
              id="btnConfirm"
              type="button"
              class="confirm-01 clear mt-5"
            >
              確認画面へ進む
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Request from "@/modules/Request";
let request = new Request();
import Message from "@/modules/Message";
import Utl from "@/modules/Utl";
export default {
  data() {
    return {
      consent: "",
      isHome: "",
      zipCode2: "",
      deliveryDate: "",
      deliveryTime: "",
      paymentMethod: "",
      part1OfAddress: "",
      part2OfAddress: "",
      part3OfAddress: "",
      part3Add: "",
      addressKana: "",
      telNo: "",
      deliveryDays: [],
      deliveryTimes: [],
      isPayBankDisp: "",
    };
  },
  mounted() {
    this.getData();
    window.scroll(0, 0);
  },
  watch: {
    deliveryDate: function () {
      this.getDeliveryTime();
    },
  },
  methods: {
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getDelivery",
        [true],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.isHome = data.isHome.toString();
          this.zipCode2 = data.zipCode2;
          this.paymentMethod = data.paymentMethod;
          this.part1OfAddress = data.part1OfAddress;
          this.part2OfAddress = data.part2OfAddress;
          this.part3OfAddress = data.part3OfAddress;
          this.part3Add = data.part3Add;
          this.addressKana = data.addressKana;
          this.telNo = data.telNo;
          this.isPayBankDisp = data.IsPayBankDisp;
          this.getDeliveryDays();
        });
    },
    getDeliveryDays() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getDeliveryDays",
        [this.isHome, this.zipCode2],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.deliveryDays = data.DeliveryDays;
          this.getDeliveryTime();
        });
    },
    getDeliveryTime() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getDeliveryTime",
        [this.deliveryDate],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.deliveryTimes = data.DeliveryTime;
        });
    },
    putData() {
      if (!this.chkConsent()) return;
      if (this.isHome == "false") {
        if (!this.chkZipCode()) return;
        if (!this.chkAddress()) return;
        if (!this.chkTelNo()) return;
      }
      if (!this.chkDeliveryDate()) return;
      if (!this.chkDeliveryTime()) return;
      if (!this.chkPaymentMethod()) return;
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "putDelivery",
        [
          this.isHome,
          this.zipCode2,
          this.deliveryDate,
          this.deliveryTime,
          this.paymentMethod,
          this.part1OfAddress,
          this.addressKana,
          this.part2OfAddress,
          this.part3OfAddress,
          this.part3Add,
          this.telNo,
        ],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (data.status == "bad") {
            Message.error().fire({
              title:data.msg,
              didClose: () => {
                switch(data.arg){
                  case "ZipCode":
                    this.$refs.zipCode2.focus();
                    break
                  case "Address1":
                    this.$refs.part1OfAddress.focus();
                    break
                  case "TelNo":
                    this.$refs.telNo.focus();
                    break
                }
              },
            });
            return;
          }
          this.$router.push("/registration/delivery/confirm");
        });
    },
    zipSearch() {
      if (!this.chkZipCode()) return;
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getAddressFromZip",
        [this.zipCode2],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (data.status == "bad") {
            Message.error().fire({
              title: data.msg,
              didClose: () => {
                this.$refs.zipCode2.focus();
                return;
              },
            });
          }
          this.part1OfAddress = data.address;
          this.addressKana = data.addressKana;
        });
    },
    chkConsent() {
      if (this.consent.length == 0) {
        Message.error().fire({
          title:
            "ご本人様が受け取る事に同意いただける方は「本人が受取ることを同意する」にチェックを入れてください。",
          didClose: () => {
            this.$refs.consent.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkZipCode() {
      let mes = Utl.chkMustInput("郵便番号", this.zipCode2);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.zipCode2.focus();
          },
        });
        return false;
      }
      mes = Utl.chkZipCode("郵便番号", this.zipCode2);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.zipCode2.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkAddress() {
      let mes = Utl.chkMustInput("住所", this.part1OfAddress);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.part1OfAddress.focus();
          },
        });
        return false;
      }
      mes = Utl.chkMustInput("住所(フリガナ)", this.addressKana);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.addressKana.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkTelNo() {
      if (this.telNo.length == 0) {
        Message.error().fire({
          title: "電話番号を入力してください。",
          didClose: () => {
            this.$refs.telNo.focus();
          },
        });
        return false;
      }
      let mes = Utl.chkNum("電話番号", this.telNo);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.telNo.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkDeliveryDate() {
      if (this.deliveryDate.length == 0) {
        Message.error().fire({
          title: "お届け指定日を選択してださい。",
          didClose: () => {
            this.$refs.deliveryDate.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkDeliveryTime() {
      if (this.deliveryTime.length == 0) {
        Message.error().fire({
          title: "お届け時間帯を選択してください。",
          didClose: () => {
            this.$refs.deliveryTime.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkPaymentMethod() {
      if (this.paymentMethod.length == 0) {
        Message.error().fire({
          title: "お支払い方法を選択してください。",
          didClose: () => {
            this.$refs.paymentMethod.focus();
          },
        });
        return false;
      }
      return true;
    },
  },
};
</script>